var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.818,
    cy: 11.318,
    r: 7,
    transform: "rotate(-45 11.818 11.318)",
    stroke: "rgb(51, 51, 51)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.354,
    y: 16.268,
    width: 2,
    height: 11,
    rx: 1,
    transform: "rotate(-45 15.354 16.268)",
    fill: "rgb(51, 51, 51)"
  }))));
};
export default SvgSearch;